import { Api } from 'vl-common/src/api';

export const getClientList = (params) => {
  return () => Api.admin.company.getAll(params).then(({ data }) => data);
};

export default getClientList;
